export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'customScreenings': { id: 'customScreenings', page: 'customScreenings', getter: () => import(/* webpackChunkName: 'customScreenings' */ 'components/bolt/customScreenings/customScreenings') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'customScreenings', getter: () => import(/* webpackChunkName: "customScreenings" */ 'components/bolt/customScreenings/customScreenings'), component: 'customScreenings' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
